import React from "react";
import { useTranslation } from "react-i18next";

import {
  useEditOrganization,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";
import { TextInput } from "@common/textInput";
import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";

function Form({ organization }: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { isRequestPending, editOrganization } = useEditOrganization(planzone);
  const [formData, setFormData] = React.useState(organization);

  React.useEffect(() => {
    setFormData(organization);
  }, [organization]);

  return (
    <form
      className={styles.organization}
      onSubmit={(e) => {
        e.preventDefault();

        !isRequestPending &&
          editOrganization({
            nextOrganization: formData,
            organization,
            planzone,
          });
      }}
    >
      <div className={styles.row}>
        <div className={styles.group}>
          <h3 className={styles.title}>
            {t("planzoneParametersPage.organization.name")} :
          </h3>
          <TextInput
            value={formData.name}
            placeholder={t("planzoneParametersPage.organization.name")}
            input={(name) => setFormData({ ...formData, name })}
          />
        </div>
        <div className={styles.group}>
          <h3 className={styles.title}>
            {t("planzoneParametersPage.organization.type")} :
          </h3>
          <TextInput
            value={formData.type}
            placeholder={t("planzoneParametersPage.organization.type")}
            input={(type) => setFormData({ ...formData, type })}
          />
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.group}>
          <h3 className={styles.title}>
            {t("planzoneParametersPage.organization.mainAddress")} :
          </h3>
          <TextInput
            value={formData.principalAddress.street}
            placeholder={t("planzoneParametersPage.organization.street")}
            input={(street) =>
              setFormData({
                ...formData,
                principalAddress: {
                  ...formData.principalAddress,
                  street,
                },
              })
            }
          />
          <div className={styles.row}>
            <TextInput
              value={formData.principalAddress.zipCode}
              placeholder={t("planzoneParametersPage.organization.zipCode")}
              input={(zipCode) =>
                setFormData({
                  ...formData,
                  principalAddress: {
                    ...formData.principalAddress,
                    zipCode,
                  },
                })
              }
            />
            <TextInput
              value={formData.principalAddress.city}
              placeholder={t("planzoneParametersPage.organization.city")}
              input={(city) =>
                setFormData({
                  ...formData,
                  principalAddress: {
                    ...formData.principalAddress,
                    city,
                  },
                })
              }
            />
          </div>
          <TextInput
            value={formData.principalAddress.state}
            placeholder={t("planzoneParametersPage.organization.state")}
            input={(state) =>
              setFormData({
                ...formData,
                principalAddress: {
                  ...formData.principalAddress,
                  state,
                },
              })
            }
          />
          <TextInput
            value={formData.principalAddress.country}
            placeholder={t("planzoneParametersPage.organization.country")}
            input={(country) =>
              setFormData({
                ...formData,
                principalAddress: {
                  ...formData.principalAddress,
                  country,
                },
              })
            }
          />
        </div>
        <div className={styles.group} />
      </div>
      <div className={styles.button}>
        <Button type="submit" press={() => {}}>
          {t("planzoneParametersPage.organization.submit")}
        </Button>
      </div>
    </form>
  );
}

export { Form };
